module.exports = __webpack_public_path__ + "static/img/Oliver-Depaoli-Kubank.9610ef3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Oliver-Depaoli-Kubank.jpg
// module id = 0cEv
// module chunks = 0